import { render, staticRenderFns } from "./Managers.vue?vue&type=template&id=4990f1bf&"
import script from "./Managers.vue?vue&type=script&lang=ts&"
export * from "./Managers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports